import { Component } from '@angular/core';

@Component({
    selector: 'app-trending',
    templateUrl: './trending.component.html',
    styleUrls: ['./trending.component.scss'],
    imports: [],
})
export class TrendingComponent {
}
